import { leadZero } from '../utils/utils';
import { diffCalendarDate } from '../diff/diff-calendar-unit';
import { newValidDateOrThrow } from '../create/create-ts-date';
import { resetISOWeek, resetYear } from '../reset/reset-unit';
var formatters = {
    // Month: 1, 2, ..., 12
    'M': function (date) { return date.getMonth() + 1; },
    // Month: 01, 02, ..., 12
    'MM': function (date) { return leadZero(date.getMonth() + 1); },
    // Quarter: 1, 2, 3, 4
    'Q': function (date) { return Math.ceil((date.getMonth() + 1) / 3); },
    // Day of month: 1, 2, ..., 31
    'D': function (date) { return date.getDate(); },
    // Day of month: 01, 02, ..., 31
    'DD': function (date) { return leadZero(date.getDate()); },
    // Day of year: 1, 2, ..., 366
    'DDD': function (date) { return diffCalendarDate(date, resetYear(date)) + 1; },
    // Day of year: 001, 002, ..., 366
    'DDDD': function (date) { return leadZero(formatters['DDD'](date), 3); },
    // Day of week: 0, 1, ..., 6
    'd': function (date) { return date.getDay(); },
    // Day of ISO week: 1, 2, ..., 7
    'E': function (date) { return date.getDay() || 7; },
    // ISO week: 1, 2, ..., 53
    'W': function (date) {
        var isoYear = +formatters['GGGG'](date);
        var start = resetISOWeek(newValidDateOrThrow(isoYear, 0, 4));
        return Math.floor(diffCalendarDate(date, start) / 7) + 1;
    },
    // ISO week: 01, 02, ..., 53
    'WW': function (date) { return leadZero(formatters['W'](date)); },
    // Year: 00, 01, ..., 99
    'YY': function (date) { return date.getFullYear().toString().slice(-2); },
    // Year: 1900, 1901, ..., 2099
    'YYYY': function (date) { return leadZero(date.getFullYear(), 4); },
    // ISO week-numbering year: 00, 01, ..., 99
    'GG': function (date) { return formatters['GGGG'](date).toString().slice(-2); },
    // ISO week-numbering year: 1900, 1901, ..., 2099
    'GGGG': function (date) {
        var startYear = date.getFullYear();
        var correction = date < resetISOWeek(newValidDateOrThrow(startYear, 0, 4))
            ? -1
            : date < resetISOWeek(newValidDateOrThrow(startYear + 1, 0, 4))
                ? 0
                : 1;
        return leadZero(startYear + correction, 4);
    },
    // Hour: 0, 1, ... 23
    'H': function (date) { return date.getHours(); },
    // Hour: 00, 01, ..., 23
    'HH': function (date) { return leadZero(date.getHours()); },
    // Hour: 1, 2, ..., 12
    'h': function (date) { return (date.getHours() % 12) || 12; },
    // Hour: 01, 02, ..., 12
    'hh': function (date) { return leadZero(formatters['h'](date)); },
    // Minute: 0, 1, ..., 59
    'm': function (date) { return date.getMinutes(); },
    // Minute: 00, 01, ..., 59
    'mm': function (date) { return leadZero(date.getMinutes()); },
    // Second: 0, 1, ..., 59
    's': function (date) { return date.getSeconds(); },
    // Second: 00, 01, ..., 59
    'ss': function (date) { return leadZero(date.getSeconds()); },
    // 1/10 of second: 0, 1, ..., 9
    'S': function (date) { return Math.floor(date.getMilliseconds() / 100); },
    // 1/100 of second: 00, 01, ..., 99
    'SS': function (date) { return leadZero(Math.floor(date.getMilliseconds() / 10)); },
    // Millisecond: 000, 001, ..., 999
    'SSS': function (date) { return leadZero(date.getMilliseconds(), 3); },
    // Timezone: -01:00, +00:00, ... +12:00
    'Z': function (date) { return formatTimezone(date.getTimezoneOffset(), ':'); },
    // Timezone: -0100, +0000, ... +1200
    'ZZ': function (date) { return formatTimezone(date.getTimezoneOffset()); },
    // Seconds timestamp: 512969520
    'X': function (date) { return Math.floor(date.getTime() / 1000); },
    // Milliseconds timestamp: 512969520900
    'x': function (date) { return date.getTime(); },
};
function formatTimezone(offset, delimeter) {
    if (delimeter === void 0) { delimeter = ''; }
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    return sign + leadZero(hours) + delimeter + leadZero(minutes);
}
export default formatters;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-date/esm/src/format/default-formatters.js
// module id = null
// module chunks = 